module.exports = __webpack_public_path__ + "static/media/Rupay.89dfd932.svg";